/** @jsx jsx */
/* eslint-disable jsx-a11y/no-autofocus, react/jsx-no-target-blank */
import React from "react"
import PropTypes from "prop-types"
import { jsx } from "theme-ui"
import styled from "@emotion/styled"
import { Link } from "gatsby"

const RootDiv = styled.div`
  margin-bottom: ${(props) => props.theme.space[3]}px;
`

const StyledLink = styled(Link)`
  color: ${(props) => props.theme.colors.breadcrumbLinkTextColor};
  font-size: ${(props) => props.theme.fontSizes[1]}px;
  margin-right: ${(props) => props.theme.space[1]}px;
  box-shadow: "none";
  &:hover {
    color: ${(props) => props.theme.colors.breadcrumbHoverLinkTextColor};
  }
`

const StyledSpan = styled.span`
  color: ${(props) => props.theme.colors.breadcrumbTextColor};
  font-size: ${(props) => props.theme.fontSizes[1]}px;
  margin-right: ${(props) => props.theme.space[1]}px;
`

const Breadcrumb = ({
  AllCollectionsText,
  CollectionTitle,
  CollectionSlug,
  Section,
  SectionTitle,
  ArticleTitle,
}) => {
  return (
    <RootDiv>
      <StyledLink to="/">{AllCollectionsText}</StyledLink>
      <StyledSpan>&rsaquo;</StyledSpan>
      {Section ? (
        <React.Fragment>
          <StyledLink to={CollectionSlug}>{CollectionTitle}</StyledLink>
          <StyledSpan>&rsaquo;</StyledSpan>
        </React.Fragment>
      ) : (
        <StyledSpan>{CollectionTitle}</StyledSpan>
      )}
      {Section && (
        <React.Fragment>
          <StyledLink to={CollectionSlug}>{SectionTitle}</StyledLink>
          <StyledSpan>&rsaquo;</StyledSpan>
        </React.Fragment>
      )}
      <StyledSpan>{ArticleTitle}</StyledSpan>
    </RootDiv>
  )
}

Breadcrumb.propTypes = {
  AllCollectionsText: PropTypes.string.isRequired,
  CollectionTitle: PropTypes.string.isRequired,
  CollectionSlug: PropTypes.string.isRequired,
  Section: PropTypes.bool.isRequired,
  SectionTitle: PropTypes.string,
  ArticleTitle: PropTypes.string.isRequired,
}

export default Breadcrumb
